import { Toaster } from 'react-hot-toast';
import { useTheme } from '../../theme/ThemeContext';

const ThemeToaster = () => {
  const { resolvedTheme } = useTheme();
  const isDarkish = resolvedTheme === 'dark' || resolvedTheme === 'dim';

  return (
    <Toaster
      position="top-right"
      gutter={12}
      containerStyle={{ top: 16 }}
      toastOptions={{
        duration: 3500,
        className: '!font-sans',
        style: {
          borderRadius: '14px',
          padding: '14px 18px',
          fontSize: '15px',
          fontWeight: 600,
          letterSpacing: '-0.01em',
          boxShadow: isDarkish
            ? 'var(--toast-shadow)'
            : '0 12px 40px -12px rgba(15, 23, 42, 0.35), 0 4px 16px rgba(15, 23, 42, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.65)',
          border: `1px solid ${isDarkish ? 'var(--toast-border)' : 'rgba(255, 255, 255, 0.55)'}`,
          background: isDarkish ? 'var(--toast-bg)' : 'rgba(255, 255, 255, 0.78)',
          backdropFilter: 'blur(14px)',
          WebkitBackdropFilter: 'blur(14px)',
          color: isDarkish ? 'var(--toast-text)' : '#0f172a',
        },
        success: {
          duration: 2800,
          iconTheme: {
            primary: '#16a34a',
            secondary: isDarkish ? '#1e293b' : '#ecfdf5',
          },
        },
        error: {
          iconTheme: {
            primary: '#dc2626',
            secondary: isDarkish ? '#1e293b' : '#fef2f2',
          },
        },
      }}
    />
  );
};

export default ThemeToaster;
